import { useState, useMemo } from "react";
import { notification, Modal, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { ClockCircleOutlined, AlignLeftOutlined, AudioOutlined, CloudUploadOutlined } from "@ant-design/icons";

import { storeUser } from "@/store/user";

import {getResponseErrorMessage} from "@/utils/api-service";

import ModalContentRemove from "../modals/ModalContentRemove";
import Cloud from '@/components/blocks/Cloud'
import Status from '@/components/blocks/Status'

import api from "@/api/index";

import "./styles/link.scss";

interface Props {
  data: any;
  index: number;
  type: string;

  remove: (index: number) => void;
}

function Link({ data, index, remove, type }: Props) {
  const descTextLen = 300;

  const [isShowModalRemove, setIsShowModalRemove] = useState(false);
  const [descLen, setDescLen] = useState<number>(descTextLen)

  const navigate = useNavigate();

  const onEdit = () => {
    const url = type === "serials" ? `/serial/${data.id}` : `/films/${data.id}`;
    navigate(url);
  };

  const showDeleteModal = () => {
    setIsShowModalRemove(true)
  }

  const onShow = () => {
    if(type === 'movies') {
      navigate(`/film-view/${data.id}`);
    } else {
      navigate(`/serial-view/${data.id}`);
    }
  };

  const onDelete = async () => {
    try {
      setIsShowModalRemove(false);

      let message = "";

      switch (type) {
        case "serials":
          await api.serie.remove(data.id);
          message = "Сериал успешно удален";
          break;

        case "movies":
          await api.movie.remove(data.id);
          message = "Фильм успешно удален";
          break;
      }

      notification.success({
        message: message ? message : "Успешно",
      });

      remove(index);
    } catch (err) {
      console.error(err);
      const messageFormatter = getResponseErrorMessage(err, 'Ошибка при удалении')
      notification.error({
        message: messageFormatter,
      });
    }
  };

  const closeModalRemove = () => {
    setIsShowModalRemove(false)
  }

  const formatCreatedAt = () => {
    const isoDate = data.created_at;
    if (!isoDate) return "-";
    const [datePart] = isoDate.split("T");
    const [year, month, day] = datePart.split("-");
    return `${day}.${month}.${year}`;
  };

  const showFullText = () => {
    setDescLen(data.description.lenght)
  }

  const voiceoversFormatted = useMemo(() => {
    if(!Array.isArray(data.voiceovers)) {
      return ''
    }

    const list = data.voiceovers.map((voiceover) => voiceover.name)

    return list.join(', ')
  }, [data])


  const isShowBtnDescFull = useMemo(() => {
    if(data && data.description && data.description.length > descTextLen && descLen <= descTextLen ) {
      return true;
    }

    return false;

  }, [descLen, data])

  const textDesc = useMemo(() => {
    if (!data?.description) {
      return '';
    }

    const description = data.description;
    const trimmedText = description.slice(0, descLen);

    
    return descLen < description.length ? `${trimmedText}...` : trimmedText;
  }, [data, descLen]);


  return (
    <div className="link">
      <div className="link__header">
        <Cloud>ID: {data.id}</Cloud>

        <Status status={data.status} data={data} type={type} />
      </div>

      <div className={"link__categories"}>
        {
          data.categories.map((category) => {
            return (
                <Cloud key={category.title}>{ category.title }</Cloud>
            )
          })
        }
      </div>

      <ul className="link__options">
        {
            type === "movies" && <li className="link__options-block">
                <AudioOutlined />

                <span>Озвучки: { voiceoversFormatted } </span>
            </li>
        }

        {type === "serials" && (
            <li className={"link__options-block"}>
              <div>
                Количество сезонов: {data.seasons_count}
              </div>
            </li>
        )}

        {type === "serials" && (
            <li className={"link__options-block"}>
              <div>
                Количество эпизодов: {data.episodes_count}
              </div>
            </li>
        )}

        <li className={"link__options-block"}>
          <ClockCircleOutlined />
          <div>
            Добавлен: {formatCreatedAt()}
          </div>
        </li>

        {data.admin_user?.user_id  && (
          <li className={"link__options-block"}>
            <CloudUploadOutlined />
            <div>
              Загрузил: {data.admin_user.login}
            </div>
          </li>
        )}

        <li className={"link__options-block"}>
          <AlignLeftOutlined />
          <div>
            <p>Описание: { textDesc }</p>
            {
              isShowBtnDescFull && <a onClick={showFullText} className="link__btn-desc-full">
                Показать все
              </a>
            }
          </div>
        </li>
      </ul>

      <div className="link__control">
        {
          storeUser.isCanRemove && <Button danger className="link__control__remove" onClick={() => showDeleteModal()}>
              Удалить
            </Button>
        }
        { <Button type="primary" onClick={() => onShow()}>Просмотр</Button>}
        <Button onClick={() => onEdit()}>Редактировать</Button>
      </div>

      <Modal
        title="Удаление элемента"
        closable={{ "aria-label": "Custom Close Button" }}
        open={isShowModalRemove}
        onOk={onDelete}
        onCancel={closeModalRemove}
        okText="Удалить"
        cancelText="Отмена"
      >
        <ModalContentRemove />
      </Modal>
    </div>
  );
}

export default Link;
